(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    
$(document).ready(function(){
  if ( $('.article__slider').length ) {
    $('.article__slider').slick();
  }  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-list"]) return;
  try {
    
$(document).ready(function(){
  var $buttons = $('.has-answer .page--faq__question');

  $buttons.click(function(){
    var $this = $(this);
    var $item = $this.parents('li');
    var $panel = $(this).siblings('.page--faq__answer');
    var $panelHeight = $panel.prop('scrollHeight');
    
    if ( $item.hasClass('active') ) {
      $item.removeClass('active');
    } else {
      $item.addClass('active');
    }

    if ( $panel.css('max-height') == '0px' ) {
      $panel.css('max-height', $panelHeight);
    } else {
      $panel.css('max-height', '0px');
    }    
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
$('.featured-product--slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-content"] && !Shopify.designMode) return;
  try {
    
var supportedFlag = $.keyframe.isSupported();

if ( supportedFlag == true && $('.flip-animation').length > 0 ) {
  
}

if ( $('.index-section__slick').length > 0 ) {
  $('.index-section__slick').slick({
    infinite: true,
    speed: 1000,
    fade: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'linear'
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"]) return;
  try {
    
$(document).ready(function(){
  var $buttons = $('.has-description .ingredient__name');

  $buttons.click(function(){
    var $this = $(this);
    var $item = $this.parents('li');
    var $panel = $(this).siblings('.ingredient__information');
    var $panelHeight = $panel.prop('scrollHeight');
    
    if ( $item.hasClass('active') ) {
      $item.removeClass('active');
    } else {
      $item.addClass('active');
    }

    if ( $panel.css('max-height') == '0px' ) {
      $panel.css('max-height', $panelHeight);
    } else {
      $panel.css('max-height', '0px');
    }    
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-our-story"]) return;
  try {
    
$(document).ready(function(){
  /*
  var timeoutId;
  var $videoBgAspect = $(".videobg-aspect");
  var $videoBgWidth = $(".videobg-width");
  var videoAspect = $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();

  function videobgEnlarge() {
    windowAspect = ($(window).height() / $(window).width());
    $videoBgWidth.width(100 + "%");
  }

  $(window).resize(function() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(videobgEnlarge, 100);
  });
  */

  $(function() {
    //videobgEnlarge();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  var $window = $(window);
  var windowLastWidth = $window.width();
  var $heroSlides = $('.hero-slider .slideshow__slide');

  heroSlideHeight();

  $(window).resize(function(){
    if($(window).width() != windowLastWidth){
      heroSlideHeight();
      windowLastWidth = $window.width();
    }
  });

  function heroSlideHeight(){
    var windowHeight = $window.innerHeight();
    var sliderHeight = windowHeight * 0.8;
    $heroSlides.each(function(){
      $(this).css('min-height', sliderHeight);
    });
  }
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"]) return;
  try {
    
$(document).ready(function(){
  var $videoBgAspect = $(".videobg-aspect");
  var $videoBgWidth = $(".videobg-width");
  var videoAspect = $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();

  $(window).resize(function() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(videobgEnlarge, 100);
  });

  $(function() {
    videobgEnlarge();
  });  

  function videobgEnlarge() {
    windowAspect = ($(window).height() / $(window).width());
    if (windowAspect > videoAspect) {
        $videoBgWidth.width((windowAspect / videoAspect) * 100 + '%');
    } else {
        $videoBgWidth.width(100 + "%")
    }
  }
});    

  } catch(e) { console.error(e); }
})();
})();
